// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class PersonalNotificationDto extends ItiBaseDto {
	public kind: string;
	public reason: string;
	public fromUser: string;
	public toUser: string;
	public message: string;
	public read: boolean;
	public generationDate: Date;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}

	public get lowercaseReason() {
		return this.reason.toLocaleLowerCase();
	}
}
